import styled from "styled-components";
export const ActivitesDoneTodayStyle = styled.div`
  .activity-container {
    border-radius: 10px;
    box-shadow: 0px 1px 10px #00000010;
    background-color: transparent;
    .header {
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      background-color: ${({ theme }) => theme.body};
      padding: 10px;
    }
    .body {
      background-color: ${({ theme }) => theme.box};
      padding: 10px;
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;
    }
  }

  .img-holder {
    padding: 0px 5px 0px 5px !important;
    img {
      border: 1px solid #d5d5d5;
      background-color: ${({ theme }) => theme.box};
      height: 50px;
    }
    @media (min-width: 1200px) {
      img {
        height: 50px !important;
      }
    }
  }
  .card-holder {
    padding: 0px 5px 0px 5px !important;
    border-radius: 5px;
    .card- {
      border-radius: 4px;
      border: 1px solid #a8a8a8;
      background-color: ${({ theme }) => theme.box};
      width: 100%;
      min-height: fit-content;
      padding-top: 10px;
      .part-1 {
        padding: 0px 5px;
        position: relative;
        .checkmark {
          font-size: 24px;
          color: ${({ theme }) => theme.text};
          margin-left: 5px;
        }
        .subject {
          a {
            color: ${({ theme }) => theme.text} !important;
          }
        }
        .title {
          margin-right: 5px;
        }
        .actions {
          position: absolute;
          left: 0px;
          h6 {
            color: #000;
            box-shadow: none;
          }
          .threedots {
            font-size: 24px;
            margin-left: 5px;
          }
          .content {
            background-color: ${({ theme }) => theme.box};
            position: absolute;
            color: ${({ theme }) => theme.text};
            box-shadow: ${({ theme }) => theme.shadow};
            left: 5px;
            top: 30px;
            border-radius: 5px;
            width: 240px;
            height: fit-content;
            .collapse-content {
              padding: 15px !important;
              .collapse-item {
                margin-bottom: 5px;
                svg {
                  font-size: 24px;
                  margin-left: 4px;
                }
                .action-done {
                  color: #359761;
                }
                .action-not-done {
                  color: #f1416c;
                }
              }
            }
          }
        }
        .recorddate {
          color: #6f5959 !important;
        }
        .createdate {
          color: #6f5959 !important;
          text-align: left !important;
        }
      }
      .part-2 {
        padding: 10px 5px;
        margin-top: 5px;
        background-color: ${({ theme }) => theme.body};
        border-top: 1px solid #ccc !important;
        border-radius: 4px;
        .action-answer {
          padding: 0.5rem;
        }
        .answer-record {
          color: #6f5959 !important;
        }
        .answer-date {
          color: #6f5959 !important;
          text-align: left;
        }
      }
    }
  }
`;
